import React, { useEffect } from 'react'
import { THEME, GlobalStyle } from './theme'
import { ThemeProvider } from 'styled-components'
import CostCalculatorForm from './components/cost-calculator-form'
import ProductsProvider from 'context/productsContext'
import { i18n } from 'locales/i18n'

const App: React.FC = () => {
  useEffect(() => {
    Object.keys(i18n.translations).forEach(lang => {
      if (window.location.href.includes(`/${lang}`)) {
        i18n.locale = lang
      }
    })
  }, [])

  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={THEME}>
        <ProductsProvider>
          <CostCalculatorForm />
        </ProductsProvider>
      </ThemeProvider>
    </>
  )
}

export default App
